<template>
  <v-dialog :value="value" persistent width="600">
    <v-card>
      <v-toolbar flat dark color="#00aff0">
        <v-toolbar-title>{{ attr.name }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('update:value', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-row 
        v-for="(row, index) in getLayout()" 
        :key="index" 
        class="mx-3"
        dense>
        <v-col v-for="item in row" :key="item.id" cols="3">
          <v-layout>
            <v-checkbox class="my-1" :label="item.name" :value="getValue(item)"
            @change="(event) => handleToggle(event, item)"/>
          </v-layout>
        </v-col>
      </v-row>
      <v-divider/>
      <v-card-actions class="grey lighten-3">
        <v-spacer></v-spacer>
        <v-btn @click="$emit('update:value', false)" width="100" color="error">Cancel</v-btn>
        <v-btn @click="saveValues" width="100" color="success">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// API
import kv from '@/axios/key-values-endpoint'
import attrApi from '@/axios/party-attribute-endpoint'

// Mixins
import { displayAlert } from '@/mixins/alert'
import { utils } from '@/mixins/utils.js'

export default {
  name: 'MultiSelect',
  data () {
    return {
      keyValues: [],
      selectedValues: []
    }
  },
  props: [
    'value',
    'attr',
    'attrvalue',
    'attrvalues'
  ],
  mixins: [displayAlert, utils],
  async created () {
    await this.getKeyValues()
    this.selectedValues = this.attrvalues.map(attr => attr.attr_key_value)
  },
  computed: {
    addedValues () {
      if (this.selectedValues.length > 0) {
        return this.selectedValues.filter(val => {
          const found = this.attrvalues.find(attrVal => {
            return attrVal.attr_key_value.id === val.id
          })
          return !found
        })
      }
      return []
    },
    removedValues () {
      if (this.attrvalues.length > 0) {
        return this.attrvalues.filter(attrVal => {
          const found = this.selectedValues.find(val => {
            return val.id === attrVal.attr_key_value.id
          })
          return !found
        })
      }
      return []
    }
  },
  methods: {
    async saveValues () {
      const promises = []
      if (this.addedValues.length > 0) {
        const addPromises = this.addedValues.map(value => {
          const payload = this.buildSavePayload(value)
          return attrApi.attributeValue.post(payload)
        })
        promises.push(...addPromises)
      }
      if (this.removedValues.length > 0) {
        const removePromises = this.removedValues.map(value => {
          return attrApi.attributeValue.delete(value.id)
        })
        promises.push(...removePromises)
      }
      if (promises.length === 0) return
      try {
        const { fulfilled, rejected } = await this.getAllSettled(promises, true)
        if (rejected.length > 0) throw rejected
        if (fulfilled.length > 0) {
          this.emitAlert(true, 'success', `${this.attr.name} has been successfully saved.`)
          this.$emit('refresh-values')
          this.$emit('sync-attr', this.attr.id)
          this.$emit('update:value', false)
        }
      } catch (err) {
        this.handleError(err)
      }
    },
    async getKeyValues () {
      await kv.keyValues.getList(this.attr.valid_value_key.id, 100, 0)
        .then(response => {
          this.keyValues = response.data
        }).catch(err => {
          this.handleError(err)
        })
    },
    getLayout() {
      const numCols = 4
      const group = this.keyValues.reduce(function (acc, curr, index) {
        const i = index
        const row = Math.floor(i / numCols)
        const mod = i % numCols
        if (mod === 0) {
          acc.push([])
        }
        acc[row].push(curr)
        return acc
      }, [])

      return group
    },
    handleToggle (event, item) {
      if (event == true) {
        this.selectedValues.push(item)
      } else {
        this.selectedValues = this.selectedValues.filter(i => i.id != item.id)
      }
    },
    buildSavePayload (val) {
      const payload = {
        attr_id: this.attr.id,
        party_id: this.$route.query.id,
        start_dt: null,
        end_dt: null,
        attr_key_value_id: val.id,
        created_by: this.$store.getters.email
      }
      return payload
    },
    getValue (item) {
      return this.selectedValues.find(attrVal => {
          return attrVal.id === item.id
        }) ? true : false
    }
  }
}
</script>
